import { render, staticRenderFns } from "./IrisButton.vue?vue&type=template&id=a4322264&"
import script from "./IrisButton.vue?vue&type=script&lang=ts&"
export * from "./IrisButton.vue?vue&type=script&lang=ts&"
import style0 from "./IrisButton.vue?vue&type=style&index=0&id=a4322264&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports